import { Link, useSearchParams } from "react-router-dom";
import SEO from "@/components/SEO";
import { CheckCircle2, Copy, Gift, Lock } from "lucide-react";
import { toast } from "sonner";

export default function SubmittedPage() {
  const [params] = useSearchParams();
  const ref = params.get("ref") || "";
  const email = params.get("email") || "";
  const bonusEligible = params.get("bonus") === "1";
  const payout = params.get("payout");

  const copy = async () => {
    try {
      await navigator.clipboard.writeText(ref);
    } catch {
      try {
        const ta = document.createElement("textarea");
        ta.value = ref;
        document.body.appendChild(ta);
        ta.select();
        document.execCommand("copy");
        ta.remove();
      } catch { /* clipboard unavailable */ }
    }
    toast.success("Reference copied");
  };

  return (
    <>
      <SEO title="Submission received" />

      <section className="search-home-hero-section" data-testid="submitted-hero" style={{ paddingBottom: 30 }}>
        <div className="main-container w-container">
          <div className="search-heading" style={{ textAlign: "center", maxWidth: 720, margin: "0 auto" }}>
            <div style={{ width: 78, height: 78, borderRadius: "50%", background: "#eaf0ff", color: "#346af8", margin: "0 auto 22px", display: "flex", alignItems: "center", justifyContent: "center" }}>
              <CheckCircle2 style={{ width: 40, height: 40 }} />
            </div>
            <div style={{ display: "inline-block", padding: "6px 14px", borderRadius: 90, background: "#eaf0ff", color: "#346af8", fontSize: 12, fontWeight: 700, letterSpacing: ".12em", textTransform: "uppercase", marginBottom: 18 }}>
              Submission received
            </div>
            <h1 className="h1 _700-bold" data-testid="submitted-headline">You&apos;re in — <span style={{ color: "#346af8" }}>we&apos;ve got it</span></h1>
            <p className="main-body-text _500-medium" style={{ marginTop: 18, color: "#4a4d5f" }}>
              We&apos;ll verify your card and notify <strong style={{ color: "#0b0d17" }}>{email}</strong> as soon as it&apos;s reviewed.
            </p>

            <div style={{ display: "flex", flexWrap: "wrap", gap: 10, justifyContent: "center", marginTop: 22 }}>
              {bonusEligible && (
                <span data-testid="submitted-welcome-bonus" style={{ display: "inline-flex", alignItems: "center", gap: 8, padding: "8px 16px", borderRadius: 90, background: "#fff", border: "1px solid #346af8", color: "#346af8", fontWeight: 700, fontSize: 13 }}>
                  <Gift style={{ width: 15, height: 15 }} /> Rate Locked for this transaction
                </span>
              )}
              <span data-testid="submitted-rate-lock" style={{ display: "inline-flex", alignItems: "center", gap: 8, padding: "8px 16px", borderRadius: 90, background: "#fff", border: "1px solid #d8dcec", color: "#0b0d17", fontWeight: 700, fontSize: 13 }}>
                <Lock style={{ width: 15, height: 15 }} /> Rate Locked for this transaction
              </span>
            </div>
          </div>
        </div>
      </section>

      <section style={{ paddingBottom: 90 }}>
        <div style={{ maxWidth: 560, margin: "0 auto", padding: "0 24px" }}>
          <div style={{ background: "#fff", padding: 30, borderRadius: 20, border: "1px solid #eaeaf0", boxShadow: "0 30px 60px -30px rgba(41,45,85,.3)", textAlign: "left" }}>
            <div style={{ fontSize: 11, fontWeight: 700, letterSpacing: ".18em", textTransform: "uppercase", color: "#346af8" }}>Reference number</div>
            <div style={{ marginTop: 8, display: "flex", alignItems: "center", justifyContent: "space-between", gap: 12 }}>
              <code data-testid="submitted-ref" style={{ fontSize: 22, color: "#0b0d17", fontWeight: 800, fontFamily: '"Hanken Grotesk", monospace' }}>{ref}</code>
              <button onClick={copy} data-testid="copy-ref" style={{ display: "inline-flex", alignItems: "center", gap: 5, fontSize: 13, fontWeight: 700, color: "#346af8", background: "none", border: "none", cursor: "pointer" }}>
                <Copy style={{ width: 14, height: 14 }} /> Copy
              </button>
            </div>
            {payout && (
              <div style={{ marginTop: 16, paddingTop: 16, borderTop: "1px solid #eaeaf0", display: "flex", alignItems: "center", justifyContent: "space-between" }}>
                <span style={{ fontSize: 11, fontWeight: 700, letterSpacing: ".18em", textTransform: "uppercase", color: "#9a93a6" }}>Estimated payout</span>
                <span style={{ fontSize: 24, fontWeight: 800, color: "#346af8", fontFamily: '"Hanken Grotesk", sans-serif' }}>${Number(payout).toFixed(2)}</span>
              </div>
            )}
            <p style={{ marginTop: 12, fontSize: 12.5, color: "#9a93a6" }}>Save this. You&apos;ll need it (plus your email) to track status.</p>
          </div>

          <div style={{ display: "flex", gap: 12, justifyContent: "center", marginTop: 26, flexWrap: "wrap" }}>
            <Link to={`/track?ref=${ref}&email=${encodeURIComponent(email)}`} data-testid="submitted-track-btn" className="primary-button w-button">
              Track this order
            </Link>
            <Link to="/" className="btn w-inline-block"><div className="btn-text">Back to home</div></Link>
          </div>
        </div>
      </section>
    </>
  );
}
